export class Befreiung {
  Jahr: number;
  IstBefreit: boolean;

  constructor(jahr?: number, befreit?: boolean) {
      if (jahr) {
        this.Jahr = jahr;
      }
      if (befreit) {
        this.IstBefreit = befreit;
      }
  }
}




// WEBPACK FOOTER //
// ./src/app/befreiung/shared/entities/befreiung.ts